import { useUserStore } from '@bv/stores';

class PermissionHelper {
  // No store here at construction time
  private get userStore() {
    return useUserStore(); // ✅ always called lazily
  }

  checkPermissionAuth(permission: string): boolean {
    return !!this.userStore.permissions.includes(permission);
  }

  checkModuleAuth(moduleName: string): boolean {
    return !!this.userStore.currentServiceDetails?.can_be_accessed_modules.includes(moduleName);
  }
}

// singleton instance
export const permissionHelper = new PermissionHelper();
